import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
 import { ToastType } from '../../models/toast-types.enum';
import { SharedService } from '../../services/shared.service';
import { ConfirmPasswordValidator } from './confirm-password.validator';

@Component({
  selector: 'lib-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;
  public loading = false;

  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
  }
  public signupForm = new FormGroup({
    email: new FormControl('', { validators: [Validators.required, Validators.email] }),
    fullName: new FormControl('', [Validators.required]),
    phoneNumber: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
  },
    {
      validators: ConfirmPasswordValidator.MatchPassword
    });

  public getFormControl(formControlName: string): FormControl {
    return this.signupForm.get(formControlName) as FormControl;
  }
  public isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.signupForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }
  public saveSignup() {
    if (this.signupForm.invalid) {
      this.sharedService.openSnackBar(
        "Check Required Fields",
        ToastType.Warning
      );
      return;
    }
    this.loading = true;
    this.getFormControl('roleId').setValue(this.settings.registerRole);

    this.data.authService.register(this.signupForm.value).subscribe((res: any) => {
      this.sharedService.openSnackBar(
        "Congratulations, your account has been successfully created.",
        ToastType.Success
      );
    }, (error: any) => {
      this.sharedService.openSnackBar(
        "Something Went Wrong.",
        ToastType.Error
      );
    });
  }
}
